<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group title="Imagens da fachada">
      <v-row>
        <slot />
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';

export default {
  name: 'CompanyPhotosCard',
  mixins: [AnalysisCardMixin],
};
</script>
